import { defineComponent } from 'vue';
import { box } from '@/ui/components/Box';
import { radio } from '@/ui/components/form/Radio';

interface SelectionBoxProps {
  value: string;
  name: string;
  nativeValue: string;
  active: boolean;
}

export const SelectionBox = defineComponent<SelectionBoxProps>({
  props: ['value', 'name', 'nativeValue', 'active'],
  setup(props, context) {
    return function render() {
      const onBoxClick = () => {
        context.emit('click');
      };

      return box([
        radio({
          value: props.value,
          name: props.name,
          nativeValue: props.nativeValue,
        }, onBoxClick, [
          context.slots.radioDefault?.(),
        ]),
        context.slots.boxDefault?.(),
      ], {
        class: `selection-box ${props.active ? 'selection-box--active' : ''}`,
        nativeOn: { click: onBoxClick },
      });
    };
  },
});
